// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  bookdemocall:"https://calendly.com/nattygains/demo-zur-software",
  upgrade:"https://nattygainscoaching.com/upgrade",
  thankyou: '/thank-you',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  checkout:'/checkout',
  about: '/about-us',
  contact: '/contact-us',
  faqs: 'https://nattygainscoaching.com/ernaehrungssoftware-faq',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id: string) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title: string) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${MOCK_TITLE}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
      verify: `${ROOTS.AUTH}/jwt/reset-password`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    workflows: `${ROOTS.DASHBOARD}/communication`,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      client_profile: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/client_profile`,
      client_profile_tab: (id: string,selecttab:string) => `${ROOTS.DASHBOARD}/user/${id}/client_profile/${selecttab}`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
        client_profile: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/client_profile`,
      },
    },
    code: {
      root: `${ROOTS.DASHBOARD}/code`,
      new: `${ROOTS.DASHBOARD}/code/new`,
    },
    ingredient:{
      root: `${ROOTS.DASHBOARD}/ingredient`,
        new: `${ROOTS.DASHBOARD}/ingredient/new`,
    },
    recipe: {
      root: `${ROOTS.DASHBOARD}/recipe`,
      new: `${ROOTS.DASHBOARD}/recipe/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/recipe/${id}/edit`,
    },
    mealplanTemplates: {
      root: `${ROOTS.DASHBOARD}/mealplan-templates`,
      new: `${ROOTS.DASHBOARD}/mealplan-templates/new`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/mealplan-templates/${id}/edit`,
    },
    resources: {
      root: `${ROOTS.DASHBOARD}/resources`,
      videocouse: `${ROOTS.DASHBOARD}/resources/videocouse`,
      guides: `${ROOTS.DASHBOARD}/resources/guides`,
      support: `${ROOTS.DASHBOARD}/resources/support`,
      socialmedia: `${ROOTS.DASHBOARD}/resources/social-media-templates`,
      landingpage: `${ROOTS.DASHBOARD}/resources/landingpage`,
      own: `${ROOTS.DASHBOARD}/resources/own-documents`,
      addon: `${ROOTS.DASHBOARD}/resources/addon`,
      pricingcalculator: `${ROOTS.DASHBOARD}/resources/pricingcalculator`,
    },
    tools:{
      root: `${ROOTS.DASHBOARD}/tools`,
      pricecalc: `${ROOTS.DASHBOARD}/tools/pricingcalculator`,
      invoice: `${ROOTS.DASHBOARD}/tools/invoice`,
      trainingplanner: `${ROOTS.DASHBOARD}/tools/trainingplan`,

    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id: string) => `/product/${id}`,
      edit: (id: string) => `/product/${id}/edit`,
      demo: {
        details: `/product/${MOCK_ID}`,
        edit: `/product/${MOCK_ID}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id: string) => `/order/${id}`,
      demo: {
        details: `/order/${MOCK_ID}`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id: string) => `/invoice/${id}`,
      edit: (id: string) => `/invoice/${id}/edit`,
      demo: {
        details: `/invoice/${MOCK_ID}`,
        edit: `/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title: string) => `/post/${paramCase(title)}`,
      edit: (title: string) => `/post/${paramCase(title)}/edit`,
      demo: {
        details: `/post/${MOCK_TITLE}`,
        edit: `/post/${MOCK_TITLE}/edit`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id: string) => `/job/${id}`,
      edit: (id: string) => `/job/${id}/edit`,
      demo: {
        details: `/job/${MOCK_ID}`,
        edit: `/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id: string) => `/tour/${id}`,
      edit: (id: string) => `/tour/${id}/edit`,
      demo: {
        details: `/tour/${MOCK_ID}`,
        edit: `/tour/${MOCK_ID}/edit`,
      },
    },
    pushNotifications: `${ROOTS.DASHBOARD}/push-notifications`,
    emailNotifications: `${ROOTS.DASHBOARD}/email-notifications`,
  },
};
